import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DocumentTemplateUtils from 'services/DocumentTemplateUtils';
import PlaceholderField from 'components/HealthRecords/Documents/DocumentTemplate/Utils/PlaceholderField';
import { isEditableBy } from '../SelectedElementEditPanel/EditableByRolesEnum';
import CPPUtils from 'services/CPPUtils';

const DocumentTemplateTextAreas = ({
  field,
  editMode,
  pageWidth,
  pageHeight,
  fieldValues,
  selectedEditElement,
  selectEditElement,
  onChange,
  updateField,
  handleStop,
  prefill,
  toggleQuickPlaceholder,
  role,
  macroData,
}) => {
  let {
    x_percent,
    y_percent,
    w_percent,
    h_percent,
    id,
    font_size,
    line_height,
    text_indent,
    letter_spacing,
    placeholder,
    style,
  } = field;

  let isEditable = editMode || isEditableBy(field?.editable_by, role);

  let value = '';

  if (fieldValues[id] !== undefined) value = fieldValues[id];
  else if (prefill && prefill[id] !== undefined) value = prefill[id];
  else if (placeholder && prefill && prefill[placeholder]) value = prefill[placeholder];

  let macroResult = CPPUtils.checkMacro(value, macroData);

  useEffect(() => {
    if (macroResult && macroResult !== value) {
      const event = {
        target: {
          name: id,
          value: macroResult,
        },
      };
      onChange(event);
    }
  }, [macroResult, value, id]);

  if (!value && editMode)
    value =
      'Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text Example Text';

  let isSelected = selectedEditElement === id;

  style = DocumentTemplateUtils.parseStyle(style || {}) || {};
  style.letterSpacing = style.letterSpacing || letter_spacing ? `${letter_spacing}px` : '';
  style.lineHeight = style.lineHeight || (line_height || '12') + 'px';
  style.textIndent = style.textIndent || (text_indent || '0') + 'px';
  if (font_size) style.fontSize = `${font_size}px`;

  let wrapperClassName = 'input-wrapper';
  if (isEditable) wrapperClassName += ' editable';
  if (isSelected) wrapperClassName += ' edit';

  let textArea = (
    <div className={wrapperClassName}>
      {isSelected && toggleQuickPlaceholder && (
        <div className="top-options">
          <PlaceholderField updateField={updateField} element={field} />
        </div>
      )}
      <textarea
        name={id}
        value={value}
        data-field-id={id}
        className="template-field"
        key={id}
        onChange={onChange}
        disabled={!isEditable}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          background: 'none',
          resize: 'none',
          overflow: 'hidden',
          fontFamily: 'Arial',
          boxSizing: 'content-box',
          fontSize: '14px',
          padding: '3px',
          ...style,
          minHeight: '0%',
          minWidth: '0%',
          maxHeight: '100%',
          maxWidth: '100%',
          margin: 0,
        }}
      >
        {value}
      </textarea>
    </div>
  );

  return DocumentTemplateUtils.getRndElement(
    id,
    textArea,
    {
      x: DocumentTemplateUtils.percentToPixel(x_percent, pageWidth),
      y: DocumentTemplateUtils.percentToPixel(y_percent, pageHeight),
      w: DocumentTemplateUtils.percentToPixel(w_percent, pageWidth),
      h: DocumentTemplateUtils.percentToPixel(h_percent, pageHeight),
    },
    editMode,
    selectEditElement,
    handleStop,
    updateField,
    { zIndex: isSelected ? 1 : 0 },
  );
};

DocumentTemplateTextAreas.propTypes = {
  field: PropTypes.object,
  selectedEditElement: PropTypes.string,
  editMode: PropTypes.bool,
  prefill: PropTypes.object,
  fieldValues: PropTypes.object,
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  selectEditElement: PropTypes.func,
  handleStop: PropTypes.func,
  onChange: PropTypes.func,
  updateField: PropTypes.func,
};

export default DocumentTemplateTextAreas;
